'use client'

import { sendDownloadPDF, submitEmailToList } from '@/lib/mailchimp'
import { PdfDownload } from '@/payload-types'
import { useState } from 'react'
import { useToast } from '../ui/use-toast'

interface IProps {
  pdfDownloadData?: PdfDownload
}

export const PdfDownloadSubmission = ({ pdfDownloadData }: IProps) => {
  const { toast } = useToast()

  const [email, setEmail] = useState('')

  async function handleSubmit(e: React.FormEvent<HTMLFormElement>) {
    e.preventDefault()
    await sendDownloadPDF(email, pdfDownloadData?.audienceId ?? '')
      .then((result) => {
        setEmail('')
        toast(result.toast)
      })
      .catch((err) => console.log('err', err))

    await submitEmailToList(email)
  }

  return (
    <div className=" py-6 px-4 my-4 text-center border-t-2 border-b-2 border-black">
      <h2 className="text-xl font-bold mb-4">To Receive a PDF report of the campaign</h2>
      <form onSubmit={handleSubmit} className="flex justify-center items-center gap-2 flex-wrap">
        <input
          type="email"
          placeholder="Enter your email address"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          className="text-sm rounded-md px-2 py-2 w-64 shadow-md focus:outline-none focus:ring-1 focus:ring-blue-100"
          required
        />
        <button
          type="submit"
          className="bg-[#FCE96A] hover:bg-[#e6cf2c] text-black font-semibold px-5 py-2 rounded-full shadow-md transition"
        >
          Submit
        </button>
      </form>
      <p className="text-xs text-gray-500 pt-2">
        *By submitting your email, you’ll also be subscribed to our monthly newsletter.
      </p>
    </div>
  )
}
